function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1667 8.92513C16.1667 12.9752 12.8834 16.2585 8.83333 16.2585C4.78325 16.2585 1.5 12.9752 1.5 8.92513C1.5 4.87504 4.78325 1.5918 8.83333 1.5918C12.8834 1.5918 16.1667 4.87504 16.1667 8.92513Z",
  fill: "#4290F3",
  fillOpacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4167 8.92513C15.4167 12.561 12.4692 15.5085 8.83333 15.5085V17.0085C13.2976 17.0085 16.9167 13.3894 16.9167 8.92513H15.4167ZM8.83333 15.5085C5.19746 15.5085 2.25 12.561 2.25 8.92513H0.75C0.75 13.3894 4.36903 17.0085 8.83333 17.0085V15.5085ZM2.25 8.92513C2.25 5.28926 5.19746 2.3418 8.83333 2.3418V0.841797C4.36903 0.841797 0.75 4.46083 0.75 8.92513H2.25ZM8.83333 2.3418C12.4692 2.3418 15.4167 5.28926 15.4167 8.92513H16.9167C16.9167 4.46083 13.2976 0.841797 8.83333 0.841797V2.3418Z",
  fill: "#4290F3"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 5.83203,
  y: 5.9248,
  width: 6,
  height: 6,
  rx: 2,
  fill: "#4290F3"
});

function SvgStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.8e2920aa.svg";
export { ForwardRef as ReactComponent };